export const ENTITY_TYPE_FILTER_OPTIONS = [
  { id: '', name: 'Todos los tipos de entidad' },
  { id: 'IE', name: 'IE' },
  { id: 'OS', name: 'Organizaciones sociales' },
  { id: 'COLECTIVO', name: 'Colectivo' },
  { id: 'JAC', name: 'JAC' },
  { id: 'JAL', name: 'JAL' }
];

export function normalizeEntityType(value) {
  const normalized = String(value || '')
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  if (normalized === 'IE' || normalized.includes('INSTITUCION EDUCATIVA')) return 'IE';
  if (normalized === 'JAC' || normalized.includes('JUNTA DE ACCION COMUNAL')) return 'JAC';
  if (normalized === 'JAL' || normalized.includes('JUNTA ADMINISTRADORA LOCAL')) return 'JAL';
  if (normalized === 'COLECTIVO' || normalized === 'COLECTIVOS') return 'COLECTIVO';
  if (
    normalized === 'OS' ||
    normalized.includes('ORGANIZACION SOCIAL') ||
    normalized.includes('ORGANIZACIONES SOCIALES')
  ) return 'OS';

  return normalized;
}

export function getRecordEntityType(record) {
  return normalizeEntityType(
    record?.entityType ??
    record?.entity_type ??
    record?.schoolType ??
    record?.school_type ??
    record?.school?.type ??
    record?.group?.school?.type ??
    record?.groupInfo?.school?.type ??
    record?.type
  );
}

export function matchesEntityType(record, selectedType) {
  return !selectedType || getRecordEntityType(record) === normalizeEntityType(selectedType);
}

export function getEntityTypeFilterLabel(selectedType) {
  if (!selectedType) return '';
  return ENTITY_TYPE_FILTER_OPTIONS.find(
    option => option.id === normalizeEntityType(selectedType)
  )?.name || selectedType;
}
